import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS } from "../data/business";
import { services } from "../data/services";
import { locations } from "../data/locations";

export default function Footer() {
  return (
    <footer className="bg-dark text-white relative noise overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24 relative">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src={BUSINESS.logo} alt="Last Cut Landscaping" className="h-14 w-auto bg-white/5 rounded-xl p-1" />
              <div>
                <div className="font-display text-xl">Last Cut</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-lime opacity-80 font-semibold">Landscaping</div>
              </div>
            </Link>
            <p className="text-white/70 text-[15px] max-w-sm leading-relaxed mb-6">{BUSINESS.tagline} — Scotland's premium landscaping team, transforming gardens across the Central Belt.</p>
            <div className="space-y-2.5 text-sm">
              <a href={`tel:${BUSINESS.phoneDial}`} className="flex items-center gap-3 text-white/90 hover:text-lime" data-testid="footer-phone"><Phone size={16} className="text-lime" /> {BUSINESS.phone}</a>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 text-white/90 hover:text-lime"><Mail size={16} className="text-lime" /> {BUSINESS.email}</a>
              <div className="flex items-center gap-3 text-white/90"><MapPin size={16} className="text-lime" /> {BUSINESS.hq}</div>
            </div>
            <div className="flex gap-3 mt-5">
              <a href={BUSINESS.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/8 hover:bg-lime hover:text-dark grid place-items-center transition" aria-label="Facebook"><Facebook size={16} /></a>
              <a href={BUSINESS.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/8 hover:bg-lime hover:text-dark grid place-items-center transition" aria-label="Instagram"><Instagram size={16} /></a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow text-lime mb-4">Services</div>
            <ul className="space-y-2 text-[14px] text-white/75">
              {services.slice(0, 8).map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-lime">{s.name}</Link></li>)}
              <li><Link to="/services" className="text-lime hover:text-lime/80 font-semibold">All services →</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow text-lime mb-4">Areas Covered</div>
            <ul className="space-y-2 text-[14px] text-white/75">
              {locations.slice(0, 9).map((l) => <li key={l.slug}><Link to={`/locations/${l.slug}`} className="hover:text-lime">Landscaping {l.name}</Link></li>)}
              <li><Link to="/locations" className="text-lime hover:text-lime/80 font-semibold">All areas →</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow text-lime mb-4">Company</div>
            <ul className="space-y-2 text-[14px] text-white/75">
              <li><Link to="/about" className="hover:text-lime">About</Link></li>
              <li><Link to="/projects" className="hover:text-lime">Projects</Link></li>
              <li><Link to="/blog" className="hover:text-lime">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-lime">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-lime">Contact</Link></li>
              <li><Link to="/quote" className="hover:text-lime">Free Quote</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[13px] text-white/55">
          <div>© {new Date().getFullYear()} Last Cut Landscaping. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-lime">Privacy</Link>
            <Link to="/terms" className="hover:text-lime">Terms</Link>
            <Link to="/sitemap" className="hover:text-lime" data-testid="footer-sitemap-link">Sitemap</Link>
            <a href="/sitemap.xml" className="hover:text-lime">sitemap.xml</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
